import React from 'react'

import Link from './Link'

const ConditionalLink = ({ children, onClick, path, ...props }) => {
  if (!path && !onClick) return children

  return (
    <Link onClick={onClick} path={path} {...props}>
      {children}
    </Link>
  )
}

export default ConditionalLink
